'use strict';

exports.__esModule = true;
exports['default'] = size;

/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */
function size(height, width) {
    if (width === void 0) {
        width = height;
    }

    return {
        height: height,
        width: width,
    };
}

module.exports = exports.default;
